import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ArrowDown, ArrowLeft } from "lucide-react";
import MayaMorning from "../../Charts/JodiCharts/MayaMorning";
import INDRADAY from "../../Charts/JodiCharts/INDRADAY";
import INDRAMORNING from "../../Charts/JodiCharts/INDRAMORNING";
import INDRANIGHT from "../../Charts/JodiCharts/INDRANIGHT";
import MAYADAY from "../../Charts/JodiCharts/MAYADAY";
import MAYANIGHT from "../../Charts/JodiCharts/MAYANIGHT";
import VEDADAY from "../../Charts/JodiCharts/VEDADAY";
import VEDAMORNING from "../../Charts/JodiCharts/VEDAMORNING";
import VEDANIGHT from "../../Charts/JodiCharts/VEDANIGHT";
import DHARMMORNING from "../../Charts/JodiCharts/DHARMMORNING";
import YUGDAY from "../../Charts/JodiCharts/YUGDAY";
import YUGMORNING from "../../Charts/JodiCharts/YUGMORNING";
import DHARMDAY from "../../Charts/JodiCharts/DHARMDAY";
import DHARMNIGHT from "../../Charts/JodiCharts/DHARMNIGHT";
import YUGNIGHT from "../../Charts/JodiCharts/YUGNIGHT";
import RADHADAY from "../../Charts/JodiCharts/RADHADAY";
import RADHAMORNING from "../../Charts/JodiCharts/RADHAMORNING";
import RADHANIGHT from "../../Charts/JodiCharts/RADHANIGHT";
import RAMADAY from "../../Charts/JodiCharts/RAMADAY";
import RAMAMORNING from "../../Charts/JodiCharts/RAMAMORNING";
import RAMANIGHT from "../../Charts/JodiCharts/RAMANIGHT";
import SHRIDAY from "../../Charts/JodiCharts/SHRIDAY";
import SHRIMORNING from "../../Charts/JodiCharts/SHRIMORNING";
import SHRINIGHT from "../../Charts/JodiCharts/SHRINIGHT";
import { nameRejext } from "../../Helpers/StringRejex";
import { GetAllCharts } from "../../Helpers/GetCharts";
import Footer from "../../Pages/Footer/Footer";
import Navbar from "../../Pages/Navbar/Navbar";
import { GET_ALL_JODI_CHART } from "../../service/admin.service";
import { comman_chat_base_url } from "../../Config/config";


const Jodi_Chart = () => {
  const navigate = useNavigate();
  const { title } = useParams();
  const location = useLocation();
  const [getData, setgetData] = useState([]);
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("0px");
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  // location.state safe fallback (direct URL hit / refresh par crash na ho)
  const pageTitle = location.state?.title || title || "";

  const handleClick = () => {
    const targetElement = document.getElementById("scroll-down");
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const getResponseData = async () => {
    const req = location.state;
    try {
      const res = await GetAllCharts(GET_ALL_JODI_CHART, req);
      setgetData(res);
    } catch (err) {
      console.error("Error fetching chart data:", err);
    }
  };

  useEffect(() => {
    getResponseData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Local charts — inhi components se render honge
  const chartMap = {
    mayamorning: MayaMorning,
    MAYANIGHT: MAYANIGHT,
    MAYADAY: MAYADAY,
    INDRANIGHT: INDRANIGHT,
    INDRAMORNING: INDRAMORNING,
    INDRADAY: INDRADAY,
    VEDAMORNING: VEDAMORNING,
    VEDADAY: VEDADAY,
    VEDANIGHT: VEDANIGHT,
    YUGMORNING: YUGMORNING,
    YUGDAY: YUGDAY,
    DHARMMORNING: DHARMMORNING,
    DHARMDAY: DHARMDAY,
    DHARMNIGHT: DHARMNIGHT,
    YUGNIGHT: YUGNIGHT,
    LAXMIMORNING: RADHAMORNING,
    LAKSHMORNING: SHRIMORNING,
    SANDHYAMORNING: RAMAMORNING,
    LAXMIDAY: RADHADAY,
    LAKSHDAY: SHRIDAY,
    SANDHYADAY: RAMADAY,
    LAXMINIGHT: RADHANIGHT,
    LAKSHNIGHT: SHRINIGHT,
    SANDHYANIGHT: RAMANIGHT,
  };

  const normalizedTitle = nameRejext(pageTitle);

  // Agar normalizedTitle chartMap mein match ho jaye -> local component
  const ChartComponent = Object.entries(chartMap).find(
    ([key]) => nameRejext(key) === normalizedTitle,
  )?.[1];

  // Warna -> common chart iframe url se load hoga
  const chartUrl = `${comman_chat_base_url}/jodi-chart/${normalizedTitle}?embed=true&color=%231E6EBE`;

  useEffect(() => {
    if (ChartComponent) return; // local chart hai to iframe listener ki zaroorat nahi

    const handleMessage = (event) => {
      if (event.data?.type === "SET_HEIGHT") {
        const newHeight = `${event.data.height}px`;
        setIframeHeight(newHeight);
        if (iframeRef.current) {
          iframeRef.current.style.height = newHeight;
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [ChartComponent]);

  return (
    <>
      <div id="scroll-up"></div>
      <Navbar />

      <div className="tw-pt-8 tw-px-0 md:tw-px-8 lg:tw-px-16 tw-min-h-screen lg:tw-mt-20 tw-mt-12">
        <div className="tw-max-w-6xl tw-mx-auto">
          {/* Header */}
          <div className="tw-text-center tw-px-4 md:tw-px-8 tw-mb-8">
            <h1 className="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-bold tw-text-gray-900 tw-mb-3">
              {pageTitle} Jodi Chart
            </h1>
            <p className="tw-text-gray-600 tw-text-xs md:tw-text-sm tw-max-w-3xl tw-mx-auto tw-mb-6">
              {pageTitle} Jodi Chart lets you explore old records, historical
              data, bracket results, live chart updates, and complete number
              history with an easy-to-use experience.
            </p>
            <button
              onClick={handleClick}
              className="tw-bg-[#1e6ebe] tw-text-white tw-font-semibold tw-px-8 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-gap-2 tw-mx-auto tw-transition-colors"
            >
              Go To Bottom
              <ArrowDown className="tw-w-4 tw-h-4" />
            </button>
          </div>

          {/* Chart Container */}
          <div className="md:tw-bg-white tw-shadow-sm tw-p-0 md:tw-p-6 tw-overflow-x-auto">
            <div className="tw-min-w-full">
              {ChartComponent ? (
                // Local chart -> is file se hi data pass karke render
                <ChartComponent chartData={getData.data} />
              ) : (
                // Common chart -> URL se iframe me load
                <div
                  style={{
                    minHeight: iframeHeight === "0px" ? "120px" : iframeHeight,
                    position: "relative",
                  }}
                >
                  {isIframeLoading && (
                    <div className="tw-absolute tw-inset-0 tw-flex tw-flex-col tw-gap-3 tw-p-4 animate-pulse">
                      <div className="tw-h-6 tw-bg-gray-300 tw-rounded"></div>
                      <div className="tw-h-6 tw-bg-gray-300 tw-rounded"></div>
                      <div className="tw-h-6 tw-bg-gray-300 tw-rounded"></div>
                    </div>
                  )}

                  <iframe
                    ref={iframeRef}
                    src={chartUrl}
                    title="Charts"
                    onLoad={() => setIsIframeLoading(false)}
                    className="tw-w-full tw-border-0 tw-transition-all tw-duration-500"
                    scrolling="no"
                    style={{
                      height: iframeHeight,
                      opacity: isIframeLoading ? 0 : 1,
                    }}
                  />
                </div>
              )}
            </div>
          </div>

          {/* Back Button */}
          <div className="tw-flex tw-justify-center tw-mt-8 md:tw-mt-8">
            <button
              onClick={() => navigate(-1)}
              className="tw-bg-[#1e6ebe] tw-text-white tw-font-semibold tw-px-8 tw-py-3 tw-rounded-lg tw-flex tw-items-center tw-gap-2 tw-transition-colors"
            >
              <ArrowLeft className="tw-w-4 tw-h-4" />
              Back
            </button>
          </div>
        </div>
      </div>

      <Footer variant="mini" />
      <div id="scroll-down"></div>
    </>
  );
};

export default Jodi_Chart;